import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { gmToolNew, pickerOption, gmToolNewPage } from "@/mixins/index";
import addPack from "./components/addPack";
import { getGiftList, szgmDelGift, getGiftCodeList, getGiftLog } from "@/api/gmToolNew/gmToolNew";
import viewGiftArticles from "./components/viewGiftArticles";
import giftCodeDetail from "./components/giftCodeDetail";
export default {
  name: "pack",
  components: {
    addPack: addPack,
    viewGiftArticles: viewGiftArticles,
    giftCodeDetail: giftCodeDetail
  },
  mixins: [gmToolNew, pickerOption, gmToolNewPage],
  data: function data() {
    return {
      reqLoading: false,
      paramsData: {
        page: 1,
        filter: ''
      },
      exreqLoading: false,
      tableData: [],
      total: 0,
      tableCopyTableList: [],
      isCode: false,
      codeLists: [],
      useGiftList: [],
      viewCodeLoading: false
    };
  },
  created: function created() {},
  methods: {
    getList: function getList(e) {
      var _this = this;

      this.paramsData.page = e;
      this.reqLoading = true;
      getGiftList(_objectSpread({}, this.paramsData)).then(function (res) {
        if (res.status == 200) {
          _this.tableData = JSON.stringify(res.data) != '[]' ? res.data.data : [];
          _this.total = JSON.stringify(res.data) != '[]' ? res.data.total : 0;
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    exportCodedata: function exportCodedata() {
      var _this2 = this;

      var columns = [{
        label: this.$t('giftCode'),
        prop: 'giftCode'
      }, {
        label: this.$t('usedCount'),
        prop: 'getCount'
      }, {
        label: this.$t('claimedPlayerId'),
        prop: 'PlayerID'
      }, {
        label: this.$t('claimTime'),
        prop: 'logTime'
      }];
      var data = this.codeLists;
      data.forEach(function (item) {
        item.PlayerID = item.PlayerID ? item.PlayerID : _this2.$t('notClaimed');
        item.logTime = item.logTime ? _this2.$times.formDate(item.logTime * 1000) : _this2.$t('notClaimed');
      });
      this.$export.csv({
        columns: columns,
        data: data,
        title: this.$t('giftCode')
      });
    },
    exportdata: function exportdata() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var columns, totalPage, list, i;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                columns = [{
                  label: _this3.$t('giftId'),
                  prop: 'giftID'
                }, {
                  label: _this3.$t('giftCode'),
                  prop: 'giftCode'
                }, {
                  label: _this3.$t('giftTotalCount'),
                  prop: 'maxCount'
                }, {
                  label: _this3.$t('claimedCount'),
                  prop: 'getCount'
                }, {
                  label: _this3.$t('maxClaimCount'),
                  prop: 'rewardCount'
                }, {
                  label: _this3.$t('startTime'),
                  prop: 'startTime'
                }, {
                  label: _this3.$t('endTime'),
                  prop: 'endTime'
                }];
                totalPage = _this3.total % 15 == 0 ? _this3.total / 15 : _this3.total / 15 + 1;
                _this3.exreqLoading = true;
                list = [];
                i = 0;

              case 5:
                if (!(i < totalPage)) {
                  _context.next = 11;
                  break;
                }

                _context.next = 8;
                return getGiftList(_objectSpread(_objectSpread({}, _this3.paramsData), {}, {
                  page: i + 1
                })).then(function (res) {
                  if (res.status == 200) {
                    list = [].concat(_toConsumableArray(list), _toConsumableArray(res.data.data));
                  }
                });

              case 8:
                i++;
                _context.next = 5;
                break;

              case 11:
                list.map(function (i) {
                  i.startTime = _this3.$times.formDate(i.startTime * 1000);
                  i.endTime = _this3.$times.formDate(i.endTime * 1000);
                });
                _this3.exreqLoading = false;

                _this3.$export.excel({
                  columns: columns,
                  data: list,
                  title: _this3.$route.meta.title
                });

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    viewCode: function viewCode(data) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this4.isCode = true;
                _this4.viewCodeLoading = true;
                _this4.useGiftList = [];
                _this4.codeLists = [];
                getGiftLog({
                  env_id: _this4.paramsData.env_id,
                  gift_id: data.giftID,
                  game_id: _this4.rawData.game_id
                }).then(function (res) {
                  _this4.useGiftList = res.data.data;
                }).finally(function () {
                  _this4.getCodeList(data);
                });

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getCodeList: function getCodeList(data) {
      var _this5 = this;

      getGiftCodeList({
        env_id: this.paramsData.env_id,
        gift_id: data.giftID,
        game_id: this.rawData.game_id
      }).then(function (res) {
        var data = res.data.data;
        data.forEach(function (item) {
          _this5.codeLists.push({
            giftCode: item.giftCode,
            getCount: item.getCount
          });
        });

        _this5.useGiftList.forEach(function (item, index) {
          _this5.codeLists.forEach(function (dItem, idx) {
            if (item.giftCode == dItem.giftCode) {
              dItem.PlayerID = item.PlayerID;
              dItem.logTime = item.logTime;
            }
          });
        });
      }).finally(function () {
        _this5.viewCodeLoading = false;
      });
    },
    deleHandle: function deleHandle(id) {
      var _this6 = this;

      this.$confirm(this.$t('confirmDeleteGift'), this.$t('prompt'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                szgmDelGift({
                  gift_id: id,
                  server_id: _this6.paramsData.server_id
                }).then(function (res) {
                  if (res.code == 200) {
                    _this6.getList(_this6.paramsData.page);

                    _this6.$message({
                      type: "success",
                      message: _this6.$t('deleteSuccess')
                    });
                  }
                });

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      })));
    }
  }
};